// Copyright 2016 Sorama B.V.

import { bindable, bindingMode, customElement, autoinject } from "aurelia-framework";

export interface Link {
    text: string;
    url: string;
}

@customElement("selector")
@autoinject
export class Selector {
    @bindable
    public title: string;

    // Selected device ID property
    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public value: unknown;

    @bindable
    public disabled: boolean;

    @bindable
    public allowNone = false;

    @bindable
    public extraUrl: Link;

    public item: unknown;

    @bindable()
    public options: unknown[];

    @bindable
    public rightAligned = false;

    // Constructor et al.
    constructor(private element: Element) {}

    public optionsChanged(newValue: unknown[]) {
        if (!newValue || !newValue.length) {
            this.item = null;
        } else if (this.item && newValue.findIndex((x) => x === this.item) == -1) {
            this.select(newValue[0]);
        }
    }

    public valueChanged(newValue: unknown, oldValue: unknown) {
        this.item = newValue;

        // Dispatch custom event when value changes
        const event = new CustomEvent("change", {
            detail: {
                newValue: newValue,
                oldValue: oldValue,
            },
            bubbles: true,
        });
        this.element.dispatchEvent(event);
    }

    private select(item: unknown): void {
        this.value = item;
        this.item = item;
    }
}
